export default "__VITE_PUBLIC_ASSET__62e93f2f__"